module.exports = __webpack_public_path__ + "assets/a61e2aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dvbt-yellow.png
// module id = 91
// module chunks = 0